import React, { useEffect, useRef } from "react";
import logo from "../../style/images/urban_naps_logo.svg";
import { useNavigate } from "react-router-dom";
import { useOrganization } from "../../context/OrganizationContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SplashScreen: React.FC = () => {
  const navigate = useNavigate();
  const toastShown = useRef(false);
  const { organizationData, loading, error } = useOrganization();

  useEffect(() => {
    const url = window.location.href;
    const hostname = new URL(url).hostname;
    const organizationName = hostname.split(".")[0];

    if (!loading) {
      if (error && !toastShown.current) {
        toastShown.current = true;
        setTimeout(() => {
          toast.error("Error fetching organization data.", {
            position: "bottom-center",
            autoClose: 3000,
          });
        }, 2000);
      } else if (!organizationData && !toastShown.current) {
        toastShown.current = true;
        setTimeout(() => {
          toast.error("Organization not available.", {
            position: "bottom-center",
            autoClose: 3000,
          });
        }, 2000);
      }
    }
  }, [loading, error, organizationData]);

  useEffect(() => {
    const url = window.location.href;
    const hostname = new URL(url).hostname;
    const organizationName = hostname.split(".")[0];

    const timer = setTimeout(() => {
      if (!loading && organizationData) {
        navigate("/homepage", { state: { organizationName } });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [navigate, loading, organizationData]);

  return (
    <div className="flex justify-center items-center h-screen">
      <img
        src={logo}
        alt="Urban Naps"
        className="max-w-full max-h-full zoom-animation"
      />
      {/* <ToastContainer /> */}
    </div>
  );
};

export default SplashScreen;
